import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { ILink, IListLibraryMediaResponse } from '../interfaces/api';
import { PaginationResponse } from 'services/commonTypes';
/**
 * please change reducer name
 */
// @ts-ignore
type MyState = RootState['media']; // ex: RootState['booking']
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['media']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];
const getDataLibraryMedia = () => selector('dataLibraryMedia') as IListLibraryMediaResponse;
const getDataLibraryLinks = () => selector('dataLibraryLinks') as PaginationResponse<ILink>;

/**
 * please replace media to your feature name
 * ex:
 * mediaSelectors => bookingSelectors
 */
const mediaSelectors = {
  getDemoData,
  getDataLibraryMedia,
  getDataLibraryLinks,
};
export default mediaSelectors;
